<template>
  <modal :width="750 - 256" name="import-csv">
    <div class="modal-content modal-content--no-padding">
      <div class="modal-header">
        <h4>Create injection from CSV</h4>
      </div>
      <div class="modal-body modal-body--big-padding">
        <label>Method</label>
        <SelectMethodComponent
          v-model="methodField"
          :configuration="configurationForMethod"
          :isMethodCompatible="true"
          modal-name="import-csv-modal__method-edit"
          style="width: 100%"
        />
        <br />
        <label>Column</label>
        <SelectColumnComponent v-model="columnField" style="width: 100%" />
        <form enctype="multipart/form-data" method="post">
          <br />
          <label>CSV file</label><br />
          <InputFileComponent v-model="files" pattern="*.csv" />
        </form>
      </div>
      <div class="modal-footer">
        <div class="modal-content__actions">
          <button :disabled="!valid || loading" class="button--accent" @click="post">Upload</button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
  import { apiInjections } from '@/api/graphql/cloud/injections';
  import ModalComponent from 'components/element/ModalComponent.vue';
  import SelectMethodComponent from 'components/element/SelectMethodComponent.vue';
  import SelectColumnComponent from 'components/element/SelectColumnComponent.vue';
  import InputFileComponent from 'components/element/InputFileComponent';
  import { DEVICE_CONFIGURATION_FOR_IMPORT } from '@/constants/methods/configuration';

  const EVENT_CREATE_INJECTION = 'createInjection';

  const MODAL_NAME = 'import-csv';

  export default {
    name: 'ImportCsvModal',

    components: {
      InputFileComponent,
      SelectColumnComponent,
      SelectMethodComponent,
      modal: ModalComponent,
    },

    props: {
      sampleId: Number,
      method: Object,
      column: Object,
    },

    data() {
      return {
        methodField: this.method,
        columnField: this.column,
        files: null,
        configurationForMethod: DEVICE_CONFIGURATION_FOR_IMPORT,
        loading: false,
      };
    },

    computed: {
      valid() {
        return this.methodField && this.columnField && this.files?.[0];
      },
    },

    setup() {
      return {};
    },

    methods: {
      close() {
        this.$modal.hide(MODAL_NAME);
      },
      async post() {
        if (!this.valid) return;
        this.loading = true;
        try {
          const file = this.files[0];
          const toBase64 = (file) =>
            new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = () => resolve(reader.result.split(',')[1]);
              reader.onerror = (error) => reject(error);
            });
          const fileBase64 = await toBase64(file);
          const result = await apiInjections.importChromatogramCSV({
            sampleId: this.sampleId,
            methodId: this.methodField.id,
            columnId: this.columnField.id,
            fileContentBase64: fileBase64,
            fileName: file.name,
          });
          if (!result.success || result.injection == null) {
            throw new Error(result.code || 'chromatogram_import.service_error');
          }

          this.close();
          await this.$nextTick();
          console.warn('Import result:', result);
          this.$emit(EVENT_CREATE_INJECTION, result.injection);
        } catch (e) {
          this.notifyResponseError &&
            this.notifyResponseError({
              message: e.message || 'Import failed',
            });
        } finally {
          this.loading = false;
        }
      },
    },
  };
</script>
